// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, useState, Fragment} from 'react';
import {Settings_context} from '../settings_ctx';
import {Button} from '../../../shared/button';
import {Editor} from '../../../shared/editor/editor';
import Chevron_right from '../img/hola2023/icons/16/chevron_right.svg';
import cn from 'classnames';
import styles from './link_buttons.module.less';

interface i_button_link_props {
    cta: string;
    link: string;
    is_transparent: boolean;
}

const Accordion_like_button_link = (props: i_button_link_props)=>{
    const {cta, link, is_transparent} = props;
    const {theme} = useContext(Settings_context);
    const cls = cn(styles.accordion_like_button,
      {
        [styles.transparent]: is_transparent,
        [styles.background]: !is_transparent
      }
    );
    return <a href={link} className={cls}>
      <p className={cn([theme.p3, theme.med, theme.color_n700])}>{cta}</p>
      <Chevron_right className={theme.color_n600}/>
    </a>;
};

const Button_link = (props: i_button_link_props)=>{
    const {cta, link, is_transparent} = props;
    const transparent_style = is_transparent ?
        {color: 'transparent'} : {};
    return <div className={styles.button_wrapper}>
      <Button {...transparent_style}
        cls={styles.button} to={link} caption={cta} />
    </div>;
};

interface i_link_buttons {
    is_in_center: boolean;
    is_accordion_like: boolean;
    buttons: i_button_link_props[];
}

export const Link_buttons =(props: i_link_buttons)=>{
    const {theme} = useContext(Settings_context);
    const {buttons, is_in_center, is_accordion_like = false} = props;
    if (is_accordion_like)
    {
        return <div
          className={cn(styles.accordion_like_buttons_container, {
            [theme.content_center]: is_in_center,
            [styles.align_center]: is_in_center,
          })}>{buttons.map(btn=><Accordion_like_button_link
            key={`${btn.cta}-${btn.link}`} {...btn}/>)}</div>;
    }
    return <div
      className={cn(styles.buttons_container, {
        [styles.content_center]: is_in_center,
        [styles.align_center]: is_in_center,
      })}>{buttons.map(btn=><Button_link
        key={`${btn.cta}-${btn.link}`} {...btn}/>)}</div>;
};

interface i_link_buttons_editor_props {
    value: i_link_buttons;
    on_change: (new_value: i_link_buttons)=>void;
    on_cancel: ()=>void;
}

export const Link_buttons_editor = (props: i_link_buttons_editor_props)=>{
    const {value, on_change, on_cancel} = props;
    const [state, set_state] = useState(value);
    return <Editor
      value={state} on_change={v=>{
        on_change(v);
        set_state(v);
      }} on_cancel={on_cancel}
      on_save={()=>on_change(state)}
      editors={[
        {key: 'is_in_center', label: 'Render in center', type: 'boolean'},
        {key: 'is_accordion_like', label: 'Accordion-like buttons',
          type: 'boolean'}
      ]} title="Link buttons">
        <Fragment>
          <hr/>
          {state.buttons.map((btn, i)=><div key={i}>
            <Editor value={btn}
              on_change={b=>{
                const new_items = [...state.buttons];
                new_items[i] = b;
                set_state({...state, buttons: new_items});
              }}
              editors={[
                {key: 'cta', label: 'Button text', type: 'text'},
                {key: 'link', label: 'Link', type: 'text'},
                {key: 'is_transparent', label: 'Make button transparent',
                  type: 'boolean'},
              ]}/>
              <Button caption="Delete item" size="xs"
                on_click={()=>{
                  set_state({
                    ...state,
                    buttons: state.buttons
                      .filter((_, index)=>index!==i)
                  });
                }}/>
              <hr/>
          </div>)}
          <Button caption="Add new item" size="xs"
            on_click={()=>set_state({
              ...state,
              buttons: [
                ...state.buttons,
                {cta: '', link: '', is_transparent: false},
              ],
            })}/>
        </Fragment>
      </Editor>;
};
